import CancelIcon from '@eduzz/houston-icons/Cancel';
import { Dialog, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import * as React from 'react';

import { useStyles } from './styles';

type ModalProps = { isOpen: boolean; handleClose: () => void; children: React.ReactNode };

function Modal({ isOpen, handleClose, children }: ModalProps) {
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down('xs'));

  return (
    <Dialog
      classes={{
        paper: classes.paper,
      }}
      data-testid='stepper-modal'
      open={isOpen}
      onClose={handleClose}
      maxWidth={false}
      fullScreen={isMobile}
    >
      <IconButton className={classes.closeIconBtn} onClick={handleClose} size='small'>
        <CancelIcon size={24} />
      </IconButton>
      {children}
    </Dialog>
  );
}

export { Modal };
